export default __webpack_public_path__ + "static/media/1.296bd358.jpg";